import fetchRequest from '../common/fetchRequest';

export default function fetchProducts (url, method = 'GET', filters = {}) {
    return fetchRequest(url, {
        method,
        data: method !== 'GET'
            ? JSON.stringify(filters)
            : null,
    });
}



// WEBPACK FOOTER //
// ./src/scripts/components/products/fetchProducts.js